import { stripHtmlTags } from '@change-corgi/core/html';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePolicyPageData } from 'src/app/pages/legal/policy/pageContext';
import { getTitle } from 'src/app/pages/legal/policy/shared/utils';

type Result = ModelHookResult<{
	title: string;
	description: string;
}>;

export function usePageMeta(): Result {
	const {
		data: { slug, excerpt },
	} = usePolicyPageData();
	const utilityContext = useUtilityContext();

	return {
		data: { title: getTitle(utilityContext, slug), description: stripHtmlTags(excerpt).trim() },
	};
}
